/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DataStructureGraphIcon16Light } from './DataStructureGraphIcon16Light';
import { DataStructureGraphIcon16Regular } from './DataStructureGraphIcon16Regular';
import { DataStructureGraphIcon16Solid } from './DataStructureGraphIcon16Solid';
import { DataStructureGraphIcon20Light } from './DataStructureGraphIcon20Light';
import { DataStructureGraphIcon20Regular } from './DataStructureGraphIcon20Regular';
import { DataStructureGraphIcon20Solid } from './DataStructureGraphIcon20Solid';
import { DataStructureGraphIcon24Regular } from './DataStructureGraphIcon24Regular';
import { DataStructureGraphIcon24Solid } from './DataStructureGraphIcon24Solid';
import { DataStructureGraphIcon32Regular } from './DataStructureGraphIcon32Regular';
import { DataStructureGraphIcon64Regular } from './DataStructureGraphIcon64Regular';
var sizes = {
    16: {
        light: DataStructureGraphIcon16Light,
        regular: DataStructureGraphIcon16Regular,
        solid: DataStructureGraphIcon16Solid,
    },
    20: {
        light: DataStructureGraphIcon20Light,
        regular: DataStructureGraphIcon20Regular,
        solid: DataStructureGraphIcon20Solid,
    },
    24: {
        regular: DataStructureGraphIcon24Regular,
        solid: DataStructureGraphIcon24Solid,
    },
    32: {
        regular: DataStructureGraphIcon32Regular,
    },
    64: {
        regular: DataStructureGraphIcon64Regular,
    },
};
export var DataStructureGraphIcon = forwardRef('DataStructureGraphIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
